import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthState} from './store/auth.state';
import {Subscription} from 'rxjs';
import {take} from 'rxjs/operators';
import {FormBaseService} from '../../shared/forms/services/formBase';
import {InputQuestion} from '../../shared/forms/models/inputField';

@Component({
    selector: 'app-login',
    template: `
        <div class="o-login o-login-bg ">

            <div class="o-login-logo t-pull-end">
                <img src="/assets/img/triple_h_logo.png" class="pull-right" style="width: 40%;">
            </div>

            <div class="card-body">
                <p class="g-font-size-22 g-mb-0 g-color-white g-px-80 text-uppercase g-py-10 g-letter-spacing-1">
                    <strong>Triple H </strong>FileShare Portal
                </p>
                <div class="row o-login-transparent g-px-80 g-py-30 g-mx-minus-15" (keydown)="onEnter($event)">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-5">

                                <!--<p class="g-font-size-15 g-color-white g-mb-10">If you're not sure what credentials to use, contact your administrator.</p>-->

                                <div *ngIf="alertError.show"
                                     class="alert alert-dismissible fade show g-brd-around g-brd-red rounded-0" role="alert">
                                    <button type="button" class="close u-alert-close--light" (click)="dismissAlert()">
                                        <span aria-hidden="true" class="g-font-size-26 g-color-white">×</span>
                                    </button>

                                    <div class="media">
                                        <span class="d-flex g-mr-10 g-mt-5">
                                            <i class="icon-ban g-font-size-20 g-color-red g-font-weight-900"></i>
                                        </span>
                                        <span class="media-body align-self-center g-color-white g-mt-4">
                                            <strong>{{alertError.message}}</strong>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12" >
                        <div class="row">
                            <div class="col-lg-5" (click)="dismissAlert()">

                                <app-forms-classic-textinput [formItem]="newForm.username"
                                                             (selected)="formBase.handleFormControl(newForm.username, $event)"
                                                             [inputLabelAttr]="'g-color-white g-font-size-15 g-font-weight-500'"
                                                             [classic]="true"
                                                             [placeholder]="'Username'"
                                                             [inputAttr]="'g-font-size-15'">
                                </app-forms-classic-textinput>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-5" (click)="dismissAlert()">
                                <app-forms-classic-textinput [formItem]="newForm.password"
                                                             (selected)="formBase.handleFormControl(newForm.password, $event)"
                                                             [inputLabelAttr]="'g-color-white g-font-size-15 g-font-weight-500'"
                                                             [placeholder]="'Password'"
                                                             [classic]="true"
                                                             [inputAttr]="'g-font-size-15'">
                                </app-forms-classic-textinput>

                                <div class="clearfix"></div>

                                <div class="mt-5 text-right">
                                    <button (click)="onSubmit()" class="btn o-login-btn-primary g-color-white g-font-size-15 g-font-weight-600">Login</button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>


            </div>
        </div>
    `,
    styles: []
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {

    loginSub$: Subscription;

    formBase: FormBaseService = new FormBaseService();

    newForm: any = {
        username: new InputQuestion({
            key: 'username',
            label: 'User Name',
            type: 'string',
            required: true,
            order: 1,
            readonly: false
        }),
        password: new InputQuestion({
            key: 'password',
            label: 'Password',
            type: 'password',
            required: true,
            order: 1,
            readonly: false
        })
    };

    alertError: any = {
        show: false
    };

    constructor(private authState: AuthState, private router: Router) { }

    dismissAlert(){
        this.alertError = {
            show: false
        };
    }

    alert(message, show = true){
        this.alertError.show = show;
        this.alertError.message = message
    }

    ngOnInit() {
        this.formBase.initForm(this.newForm);

    }

    onSubmit() {
        let credentials = this.formBase.form.value;
        this.loginSub$ = this.authState
            .login(credentials)
            .pipe(take(1))
            .subscribe(this.handleLogin.bind(this));
    }

    handleLogin(success) {
        if(!success) {
            this.handleFailure();
        }
    }

    handleFailure() {
        this.formBase.form.controls['password'].reset();
        this.alert('Username or password are incorrect')
    }

    ngOnDestroy() {
        this.loginSub$ && this.loginSub$.unsubscribe();
    }

    onEnter(event){
        if(event.keyCode == 13) this.onSubmit();
    }

    ngAfterViewInit(){
        this.testLogin()
    }

    testLogin(){
        //setTimeout(() => this.onSubmit())
    }
}
